// extracted by mini-css-extract-plugin
module.exports = {"subsTxt":"JvxBy","logoutToast":"ZXukI","spin":"jn5cz"};